<template>
  <div class="in-out-mail-wrapper">
    <el-row class="btn-group">
      <el-dropdown trigger="click" class="btn-item" @command="val => handleCommand(val, 'tag')">
        <el-button type="default" size="medium">
          {{ $t('after-sales::in-box::in_out_mail_mark') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu :appendToBody="false" slot="dropdown">
          <el-dropdown-item :command="item.value" v-for="(item, i) in tagList" :key="i">
            <span
              :style="
                `margin-right:4px;border-radius: 2px;display:inline-block;width:10px;height: 8px;vertical-align: middle;background: ${item.color}`
              "
            ></span>
            {{ item.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-row>
    <z-table
      ref="table"
      v-loading="loading"
      :data="tableData"
      :selectable="handleCheck"
      @selection-change="handleSelectionChange"
      :columns="columns"
      :pagination="false"
      @page-change="getListData"
    >
      <template #shopName="{ row }">
        <p class="oneline" :title="row.shopName">{{ $dataCheck(row.shopName) }}</p>
      </template>
      <template #subject="{ row }">
        <p class="oneline" :title="row.subject">{{ $dataCheck(row.subject) }}</p>
      </template>
      <template #fromHeader>
        {{ $t('after-sales::in-box::in_out_mail_send_email') }}
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">
            <div>
              <span class="dot"></span>
              {{ $t('after-sales::in-box::in_out_mail_user_send') }}
            </div>
            <div>
              <span class="dot cus"></span>
              {{ $t('after-sales::in-box::in_out_mail_customer_send') }}
            </div>
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
      <template #from="{ row }">
        <div>
          <div v-if="row.type === 2">
            <span class="dot"></span>
            {{ $dataCheck(row.from) }}
          </div>
          <div v-else-if="row.type === 1">
            <span class="dot cus"></span>
            {{ $dataCheck(row.from) }}
          </div>
        </div>
      </template>
      <template #sentDate="{ row }">
        <p>{{ $dataCheck(row.sentDate) }}</p>
      </template>
      <template #tagList="{ row }">
        <template v-if="row.tagList && row.tagList.length">
          <el-tag
            v-for="(tag, i) in row.tagList"
            :key="i"
            size="small"
            class="tag-cell-item"
            @close="handleCloseTags(row, tag.id)"
            closable
            :title="tag.allName"
            :style="
              `background-color: ${tag.color};
              border-color: ${tag.color};
              color: #fff;margin-right: 4px;margin-bottom: 4px;`
            "
          >
            {{ tag.allName }}
          </el-tag>
        </template>
        <span v-else>--</span>
      </template>
      <template #operate="{ row }">
        <el-button @click="handleTo(row)" type="text">{{ $t('after-sales::in-box::in_out_mail_detail') }}</el-button>
        <el-button v-if="row.type === 1" @click="handleBtn('back', row)" type="text">
          {{ $t('after-sales::in-box::in_out_mail_reply') }}
        </el-button>
      </template>
    </z-table>
    <drawerEmail v-model="drawerVisable" :drawRow="drawRow"></drawerEmail>
  </div>
</template>
<script>
import moment from 'moment'
import drawerEmail from '../components/write-email'
import { updateEmailListItemTag, getEmailContact } from '@/server/after-sales.js'
import { putMerchantConfig } from '@/server/common'
export default {
  name: 'orderInfo',
  components: {
    drawerEmail
  },
  props: {
    params: {
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      drawerVisable: false,
      selections: [],
      drawRow: {
        type: 'write',
        item: {}
      },
      tagList: [],
      columns: [
        {
          type: 'selection',
          fixed: true
        },
        {
          prop: 'index',
          label: this.$t('after-sales::in-box::in_out_mail_num'),
          minWidth: '80'
        },
        {
          prop: 'shopName',
          label: this.$t('after-sales::in-box::in_out_mail_shop'),
          minWidth: '150'
        },
        {
          prop: 'sentDate',
          label: this.$t('after-sales::in-box::in_out_mail_deliver_time'),
          minWidth: '240'
        },
        {
          prop: 'from',
          label: this.$t('after-sales::in-box::in_out_mail_send_email'),
          slotHeaderName: 'fromHeader',
          minWidth: '220'
        },
        {
          prop: 'subject',
          label: this.$t('after-sales::in-box::in_out_mail_subject'),
          width: '150'
        },
        {
          prop: 'categoryName',
          label: this.$t('after-sales::in-box::in_out_mail_sort'),
          width: '120',
          formatter: row => this.$dataCheck(row.categoryName)
        },
        {
          prop: 'tagList',
          label: this.$t('after-sales::in-box::in_out_mail_tag'),
          width: '160'
        },
        {
          prop: 'staffName',
          label: this.$t('after-sales::in-box::in_out_mail_handler'),
          width: '120',
          formatter: row => this.$dataCheck(row.staffName)
        },
        {
          prop: 'operate',
          label: this.$t('after-sales::in-box::in_out_mail_opt'),
          width: '180',
          fixed: 'right'
        }
      ],
      tableData: [],
      noMore: false
    }
  },
  async mounted() {
    this.initDictData()
    this.init(this.params, true)
  },
  methods: {
    handleCheck(row, index) {
      return row.type === 1
    },
    async initDictData() {
      this.loading = true
      const [tags] = await Promise.all([putMerchantConfig(2)])
      if (tags.data.code === 0) {
        const list = []
        tags.data.data.forEach(item => {
          if (item.childrens.length) {
            item.childrens.forEach(im => {
              list.push({ label: `${im.parentName}-${im.name}`, value: im.id, color: im.color })
            })
          } else {
            list.push({ label: `${item.name}`, value: item.id, color: item.color })
          }
        })
        this.tagList = list
      }
      this.loading = false
    },
    handleBtn(type, row) {
      this.drawRow.type = type
      if (row) {
        this.drawRow.item = row
      }
      this.drawerVisable = true
    },
    init(params) {
      this.getListData(params, true)
    },

    async getListData(params, init = false) {
      this.loading = true
      const { data } = await getEmailContact({
        inboxId: this.params.emailId,
        shopId: this.params.shopId
      })
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data.map((item, index) => {
          return {
            index: index + 1,
            ...item
          }
        })
      }
    },
    async handleCloseTags(row, id) {
      this.loading = true
      const { data } = await updateEmailListItemTag({
        ids: String(row.id),
        tagIds: row.tagList
          .map(item => item.id)
          .filter(item => item !== id)
          .join(',')
      })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('after-sales::in-box::in_out_mail_delete'))
        this.getListData(this.params)
      }
    },
    handleTo(row) {
      this.$router.push({
        path: '/email-detail',
        query: {
          emailId: this.params.emailId,
          name: 'detailInfo',
          type: this.params.type,
          changeType: row.type,
          shopId: this.params.shopId,
          changeShopId: row.shopId,
          changeEmailId: row.id
        }
      })
    },
    async handleCommand(val, about) {
      let res = {}
      if (!this.selections.length) {
        this.$message.warning(this.$t('after-sales::in-box::in_out_mail_select_mail'))
        return false
      }
      this.loading = true
      if (about === 'tag') {
        const { data } = await updateEmailListItemTag({
          ids: this.selections.map(item => item.id).join(','),
          isAdd: 1,
          tagIds: String(val)
        })
        res = data
      }
      if (res.code === this.$code) {
        this.$message.success(this.$t('after-sales::in-box::in_out_mail_opt_success'))
        // this.params
        this.getListData()
      }
      this.loading = false
    },
    handleSelectionChange(selection) {
      this.selections = selection
    }
  }
}
</script>
<style lang="scss" scoped>
.dot {
  width: 5px;
  height: 5px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
  background-color: $--color-primary;
  &.cus {
    background-color: $--color-warning;
  }
}
.in-out-mail-wrapper {
  ::v-deep {
    .el-tag__close {
      color: #fff;
      &:hover {
        background-color: inherit;
      }
    }
  }
  .btn-group {
    margin-bottom: 16px;
    .btn-item {
      margin-left: 0;
      margin-right: 10px;
    }
  }
}
</style>
